module.exports = __webpack_public_path__ + "img/8.929d275e.jpg";